import { render } from "./PresentItemOwnList.vue?vue&type=template&id=b920fb4a"
import script from "./PresentItemOwnList.vue?vue&type=script&lang=js"
export * from "./PresentItemOwnList.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__